import { render, staticRenderFns } from "./InspectionType.vue?vue&type=template&id=e46f374c"
import script from "./InspectionType.vue?vue&type=script&lang=js"
export * from "./InspectionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports